// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "module." + {"90":"live-search","979":"swiper","995":"focus-trap"}[chunkId] + ".js?v=" + {"90":"5cae9ddd46052b45d6f9","979":"b0ba6c9176b347b8b9d3","995":"59fd0bfc49dcbcb6f0e0"}[chunkId] + "";
};